import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, Modal, Stack, styled } from '@mui/material';
import { Item, Label, WsButton, WsColors } from 'wisestep-base';

import Checkmark from './check.png';

const ModalBox = styled(Box)({
  position: 'absolute' as const,
  top: '37%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

const ZoomConfirmationModal = ({ modal, setModal }) => (
  <Modal open={modal} onClose={() => setModal(false)}>
    <ModalBox borderRadius={1.5} bgcolor={WsColors.White} p={1} width={540} height={370}>
      <Grid justifyContent="center" container>
        <Grid item>
          <Grid container justifyContent="flex-end">
            <CloseIcon
              sx={{
                cursor: 'pointer',
                marginLeft: '94%',
                marginTop: '1%',
                color: WsColors.Red500,
              }}
              fontSize={'small'}
              onClick={() => setModal(false)}
            />
          </Grid>
          <Stack
            direction="column"
            alignItems="center"
            justifyContent="space-between"
            marginTop={6}
            marginBottom={2}
          >
            <img src={Checkmark} alt="CareerBuilder" width="50" height="50" />
          </Stack>

          <Item>
            <Label
              sx={{
                fontSize: '1.2rem',
                minWidth: 400,
                margin: 2,
                textAlign: 'center',
                color: '#8f9298',
                fontStyle: 'bold',
              }}
            >
              All Accounts are fetched successfully
            </Label>
          </Item>
        </Grid>

        <Grid item justifyContent="center" direction="row" marginBottom={4}>
          <Stack justifyContent="center" direction="row">
            <Item>
              <WsButton size="large" variant="contained" onClick={() => setModal(false)}>
                Okay
              </WsButton>
            </Item>
          </Stack>
        </Grid>
      </Grid>
    </ModalBox>
  </Modal>
);
export default ZoomConfirmationModal;
